<script setup>
import { computed } from 'vue'

const props = defineProps({
  placeholder: {
    type: String,
  },
  field: {
    type: String,
  },
  form: {
    type: Object,
  },
  options: {
    type: Array,
  },
  optionValue: {
    type: String,
  },
  optionLabel: {
    type: String,
  },
})

const model = defineModel({ required: true })

const error = computed(() => props.form.errors[props.field])
</script>

<template>
  <div class="input-group">
    <Select
      :placeholder="placeholder"
      :invalid="error"
      v-model="model"
      :options="options || []"
      :optionValue="optionValue"
      :optionLabel="optionLabel"
      @change="form.clearErrors(field)"
    ></Select>
    <p v-if="error" class="text-red-500 text-sm break-normal">
      <small>{{ error }}</small>
    </p>
  </div>
</template>
